enum CountryIds {
  Australia = '039f60d5-1b38-451a-b191-5e4b86273324',
}

export { CountryIds }
